/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-alert */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import mem from '@/service/member';
import que from '@/service/questions';

const state = {
  isLoading_login: false,
  isLogin: false,
  loginInfo: '',
  userinfo_pk: '',
  userinfo: {
    radcount: 0
  },
  status: 'test',
  api_token: '',
  publicValue: {
    year: [],
    method: [],
    lanuage: []
  }
};

// actions
const actions = {
  getRecord({
    state,
    commit
  }, data) {
    const con = mem.QuestionsRecord();
    return con;
  },
  buyquestions({
    state,
    commit
  }, data) {
    const postData = {
      examId: data.examid,
    };
    const con = que.buyquestions(postData);

    return con;
  },
  checkLogin({
    commit
  }) {
    commit('changeLoading', true);
    const con = mem.checklogin();
    con.then((response) => {
      if (response.data.id) {
        commit('saveUserinfo', response.data);
        commit('isLogin', {
          TF: true,
          member_id: 'VIP',
          loginInfo: ''
        });
        commit('changeLoading', false);
    
      } else {
        commit('isLogin', {
          TF: false,
          member_id: 'test',
          loginInfo: response.data.info
        });
        commit('changeLoading', false);
        // router.push({ to: 'index' });
      }
    });
    return con;
  },
  Login({
    commit
  }, data) {
    commit('changeLoading', true);
    const postData = {
      member_id: data.member_id,
      password: data.password,
    };
    const con = mem.login(postData);
    con.then((response) => {
        if (response.data.id) {
          commit('saveUserinfo', response.data);
          commit('loginSetToken', response.data);
          commit('isLogin', {
            TF: true,
            member_id: 'VIP'
          });
          commit('changeLoading', false);
        } else {
          commit('isLogin', {
            TF: false,
            member_id: 'test'
          });
          commit('changeLoading', false);
       
        }
      })
      .catch((error) => {
      });
    return con;
  },
  // ===========
  async getIndexLayoutdata({
    commit
  }) {
    const data = await que.getIndexLayoutdata().then((data) => {
      return data.data.result;
    });
    commit("setPublicValue", data);
  },
  async searchExamList({
    commit,
  }, sdata) {
    const data = await que.searchExamList(sdata).then((data) => {
      return data.data.result;
    });

    return data;
  }
  // ========
};
// mutations
const mutations = {
  changeLoading(state, data) {
    state.isLoading_login = data;
  },
  isLogin(state, data) {
    state.isLogin = data.TF;
    state.status = data.member_id;
    state.loginInfo = data.loginInfo;
  },
  loginSetToken(state, data) {
    localStorage.setItem('api_token', data.api_token);
    state.api_token = localStorage.getItem('api_token');
  },
  saveUserinfo(state, data) {
    state.userinfo_pk = data.id;
    state.userinfo = data;
    
  },
  setPublicValue(state, data) {
    state.publicValue.year = data.year;
    state.publicValue.method = data.method;
    state.publicValue.lanuage = data.lanuage;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
